import React, { useEffect, useState } from 'react';
import { Link,useParams,useNavigate } from 'react-router-dom';
import BlogService from '../../api/services/BlogService';
import MainPagetitle from '../../layouts/MainPagetitle';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Modal,Button } from 'react-bootstrap'; 
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const EditBlog = () => {
  var imageUrl = process.env.REACT_APP_LARAVEL_BLOG_IMAGE_URL; 
  const params = useParams();
  const navigate = useNavigate();
  const [blogModal, setBlogModal] = useState(false);
  const [blog, setBlog] = useState([]);
  const [file, setFile] = useState()
  const [error, setError] = useState([]);
 const [description, setDescription] = useState("");
 const [isLoading, setisloading] = useState(true);
 const [Germandescription, setGermanDescription] = useState("");
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {
    var id = params.id;
    getBlogByID(id);
  }
  else {
    navigate('/')
  }
  }, []);
  
  const getBlogByID = async (id) => {
    try {
      let blogList = await BlogService.show(id).json();
      setBlog(blogList.data);
      setisloading(false);
    } catch (error) {
        if (error.name === 'HTTPError') {
            const errorJson = await error.response.json();
            setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
          }
    }
  };

  const handleEditorChange = (e, editor) => {
    const data = editor.getData()
    setDescription(data);
  }
  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var blog_image = fileReader.result
      setFile(blog_image)
    }
  }
  const handleGermanEditorChange = (e, editor) => {
    const data = editor.getData()
    setGermanDescription(data);
  }
  const onSubmitForm = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {

        "title": event.target.title.value,
        "de_title": event.target.de_title.value,
        "sub_title": event.target.sub_title.value,
        "de_sub_title": event.target.de_sub_title.value,
        "blog_image": file ? file.split(',')[1] : "",
        "description": description,
        "de_description": Germandescription

      }
      console.log(userData)
      let responseData = await BlogService.update(params.id,userData).json()
      console.log(userData)
      if (responseData.status === true) {
        setBlogModal(true)
      }
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message)
      }
      }
    
  };

  return (
    <>
      <MainPagetitle mainTitle="Edit Blog" pageTitle={'Edit Blog'} parentTitle={'Home'} />
      <div className="container-fluid">
        <form className="form-valide" onSubmit={onSubmitForm}>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Edit Blog</h4>
                </div>
                <div className="card-body">
                  <div className="row">

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username" 
                       defaultValue={
                                blog.title
                                ?  blog.title
                                : ''
                            } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" 
                        defaultValue={blog.de_title ?  blog.de_title : ''} 
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Sub Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='sub_title' id="val-username" 
                       defaultValue={
                                blog.sub_title
                                ?  blog.sub_title
                                : ''
                            } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Sub Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_sub_title' id="val-username" 
                        defaultValue={blog.de_sub_title ?  blog.de_sub_title : ''} 
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label"> Blog Image <span className="text-danger">*</span></label>
                      {blog.blog_image ? <img className="img-drop-area" height={100} width={100}  name="blog_image" src={file ? file: imageUrl+ blog.blog_image} alt='' /> :null}
                      <input type="file" className="form-control" name='blog_image' id="val-number"  onChange={onFileChange} />
                    </div>

                    <div className="col-xl-12 mb-3">
                    <label htmlFor="val-number" className="form-label"> English Blog Description <span className="text-danger">*</span></label>
                        <div className="custom-ekeditor">
                            <CKEditor
                                editor={ClassicEditor}
                                name="description"
                                data={blog.description}
                                onChange={handleEditorChange}
                            />
                        </div>
                    </div>
                    <div className="col-xl-12 mb-3">
                    <label htmlFor="val-number" className="form-label"> German Blog Description <span className="text-danger">*</span></label>
                        <div className="custom-ekeditor">
                            <CKEditor
                                editor={ClassicEditor}
                                name="de_description"
                                data={blog.de_description === null ?  '' : blog.de_description}
                                onChange={handleGermanEditorChange}
                            />
                        </div>
                    </div>
 

                  </div>
                  <h5 style={{color:'red'}}>{error}</h5>
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
         
        </form>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={blogModal}>
            <Modal.Header>
              <Modal.Title>Update </Modal.Title>
              <Button variant="" className="btn-close" onClick={() => setBlogModal(false)}></Button>
            </Modal.Header>
            <Modal.Body>Update Blog Successfully!!!.</Modal.Body>
            <Modal.Footer>
              <Link className="btn btn-primary" to={'/admin/blogs'} variant="danger light" onClick={() => setBlogModal(false)}>Close</Link>
            </Modal.Footer>
          </Modal>
    </>
  );
};
export default EditBlog;